/**
 * Helper function to get nested keys of an object in dot notation format.
 *
 * @param {Object} obj - The object to get the keys from.
 * @param {string} [parentKey=''] - The base key to prepend to each key.
 * @param {Array<string>} [leafKeys=[]] - List of keys that should be treated as leaves, even if their values are objects.
 *
 * @returns {Array<string>} - Returns an array of strings representing the keys in dot notation format.
 */
export const getNestedDotNotationKeys = (
  obj,
  parentKey = '',
  leafKeys = [],
) => {
  const dotNotations = [];

  const isObject = (val) => val && typeof val === 'object';

  const keys = Object.keys(obj ?? {});

  if (!keys.length && parentKey) {
    return [parentKey];
  }

  keys.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      if (!leafKeys.includes(key) && isObject(obj[key])) {
        dotNotations.push(
          ...getNestedDotNotationKeys(obj[key], newKey, leafKeys),
        );
      } else {
        dotNotations.push(newKey);
      }
    }
  });
  return dotNotations;
};
